(function () {
    'use strict';

    var vm = require('../../components/bookings/Reports');

    var Charter = require('../../modules/Charter');

    var $bookingsVsQuotesChart = $('#bookings-vs-quotes-chart');
    var $usedPromoCodesChart = $('#used-promo-codes-chart');
    var $bookingsChart = $('#bookings-chart');

    if ($bookingsVsQuotesChart.length > 0) {
        bookingsVsQuotes();
    }

    if ($usedPromoCodesChart.length > 0) {
        usedPromoCodes();
    }

    if ($bookingsChart.length > 0) {
        bookings();
    }

    function getLabels(items, dataPeriod) {
        return Object.keys(items).map(function (item) {
            return getFormattedDate(item, dataPeriod);
        });
    }

    function getInputOutputFormatsForDates(dataPeriod) {
        var inputFormat = '';
        var outputFormat = '';

        if (dataPeriod === 'daily') {
            inputFormat = 'YYYY-MM-DD';
            outputFormat = 'MMMM Do YYYY';
        } else {
            inputFormat = 'YYYY-MM';
            outputFormat = 'MMMM YYYY';
        }

        return {
            input: inputFormat,
            output: outputFormat,
        };
    }

    function getFormattedDate(date, dataPeriod) {
        var formats = getInputOutputFormatsForDates(dataPeriod);

        return moment(date, formats.input).format(formats.output);
    }

    function getDateFromLabel(label, dataPeriod) {
        var inputFormat = '';
        var outputFormat = '';

        if (dataPeriod === 'daily') {
            inputFormat = 'MMMM Do YYYY';
            outputFormat = 'YYYY-MM-DD';
        } else {
            inputFormat = 'MMMM YYYY';
            outputFormat = 'YYYY-MM';
        }

        return moment(label, inputFormat).format(outputFormat);
    }

    function getCounts(items) {
        return $.map(items, function (item) {
            return item.length;
        });
    }

    function bookingsVsQuotes() {
        var dataPeriod = 'daily';
        var tableInitialised = false;
        var bookingsVsQuotes = window.greenmotion.reports.bookingsVsQuotes;
        var bookingsVsQuotesChart = Charter.line(
            $bookingsVsQuotesChart,
            getLabels(bookingsVsQuotes.bookings.daily, dataPeriod),
            [getCounts(bookingsVsQuotes.bookings.daily), bookingsVsQuotes.quotes.daily]
        );
        var $filterButtons = $('.bookings-vs-quotes-filter-buttons');
        var $filterDailyButton = $filterButtons.find('.filter-daily-button');
        var $filterMonthlyButton = $filterButtons.find('.filter-monthly-button');
        var $backToChartViewLink = $bookingsVsQuotesChart.parents('.panel-body').find('.back-to-chart-view');

        $bookingsVsQuotesChart.on('click', function (e) {
            var activePoints = bookingsVsQuotesChart.getPointsAtEvent(e);

            if (!activePoints[0]) {
                return;
            }

            var date = getDateFromLabel(activePoints[0].label, dataPeriod);

            vm.$children[0].$set('viewMode', 'details');
            vm.$children[0].$set('date', date);

            var bookings = bookingsVsQuotes.bookings[dataPeriod][date];

            vm.$children[0].$set('bookings', bookings);

            $filterButtons.hide();

            vm.$nextTick(function () {
                if (!tableInitialised) {
                    $('.footable-paginated').footable();

                    tableInitialised = true;
                } else {
                    $('.footable-paginated').trigger('footable_redraw');
                }
            });
        });

        $filterDailyButton.on('change', function (e) {
            dataPeriod = 'daily';

            bookingsVsQuotesChart.destroy();
            bookingsVsQuotesChart = Charter.line(
                $bookingsVsQuotesChart,
                getLabels(bookingsVsQuotes.bookings.daily, dataPeriod),
                [getCounts(bookingsVsQuotes.bookings.daily), bookingsVsQuotes.quotes.daily]
            );
        });

        $filterMonthlyButton.on('change', function (e) {
            dataPeriod = 'monthly';

            bookingsVsQuotesChart.destroy();
            bookingsVsQuotesChart = Charter.line(
                $bookingsVsQuotesChart,
                getLabels(bookingsVsQuotes.bookings.monthly, dataPeriod),
                [getCounts(bookingsVsQuotes.bookings.monthly), bookingsVsQuotes.quotes.monthly]
            );
        });

        $backToChartViewLink.on('click', function (e) {
            $filterButtons.show();
        });
    }

    function usedPromoCodes() {
        var dataPeriod = 'daily';
        var tableInitialised = false;
        var usedPromoCodes = window.greenmotion.reports.usedPromoCodes;
        var usedPromoCodesChart = Charter.bar($usedPromoCodesChart, getLabels(usedPromoCodes.with.daily, dataPeriod), [
            getCounts(usedPromoCodes.with.daily),
            getCounts(usedPromoCodes.without.daily),
        ]);
        var $filterButtons = $('.used-promo-codes-filter-buttons');
        var $filterDailyButton = $filterButtons.find('.filter-daily-button');
        var $filterMonthlyButton = $filterButtons.find('.filter-monthly-button');
        var $backToChartViewLink = $usedPromoCodesChart.parents('.panel-body').find('.back-to-chart-view');

        $usedPromoCodesChart.on('click', function (e) {
            var activePoints = usedPromoCodesChart.getBarsAtEvent(e);

            if (!activePoints[0]) {
                return;
            }

            var date = getDateFromLabel(activePoints[0].label, dataPeriod);

            vm.$children[1].$set('viewMode', 'details');
            vm.$children[1].$set('date', date);

            var bookings = usedPromoCodes.with[dataPeriod][date];

            vm.$children[1].$set('bookings', bookings);

            $filterButtons.hide();

            vm.$nextTick(function () {
                if (!tableInitialised) {
                    $('.footable-paginated').footable();

                    tableInitialised = true;
                } else {
                    $('.footable-paginated').trigger('footable_redraw');
                }
            });
        });

        $filterDailyButton.on('change', function (e) {
            dataPeriod = 'daily';

            usedPromoCodesChart.destroy();
            usedPromoCodesChart = Charter.bar($usedPromoCodesChart, getLabels(usedPromoCodes.with.daily, dataPeriod), [
                getCounts(usedPromoCodes.with.daily),
                getCounts(usedPromoCodes.without.daily),
            ]);
        });

        $filterMonthlyButton.on('change', function (e) {
            dataPeriod = 'monthly';

            usedPromoCodesChart.destroy();
            usedPromoCodesChart = Charter.bar(
                $usedPromoCodesChart,
                getLabels(usedPromoCodes.without.monthly, dataPeriod),
                [getCounts(usedPromoCodes.with.monthly), getCounts(usedPromoCodes.without.monthly)]
            );
        });

        $backToChartViewLink.on('click', function (e) {
            $filterButtons.show();
        });
    }

    function bookings() {
        var dataPeriod = 'daily';
        var tableInitialised = false;
        var bookings = window.greenmotion.reports.bookings;
        var bookingsChart = Charter.line($bookingsChart, getLabels(bookings.daily, dataPeriod), [
            getCounts(bookings.daily),
        ]);
        var $filterButtons = $('.bookings-filter-buttons');
        var $filterDailyButton = $filterButtons.find('.filter-daily-button');
        var $filterMonthlyButton = $filterButtons.find('.filter-monthly-button');
        var $backToChartViewLink = $bookingsChart.parents('.panel-body').find('.back-to-chart-view');

        $bookingsChart.on('click', function (e) {
            var activePoints = bookingsChart.getPointsAtEvent(e);

            if (!activePoints[0]) {
                return;
            }

            var date = getDateFromLabel(activePoints[0].label, dataPeriod);

            vm.$children[0].$set('viewMode', 'details');
            vm.$children[0].$set('date', date);

            var bookingsData = bookings[dataPeriod][date];

            vm.$children[0].$set('bookings', bookingsData);

            $filterButtons.hide();

            vm.$nextTick(function () {
                if (!tableInitialised) {
                    $('.footable-paginated').footable();

                    tableInitialised = true;
                } else {
                    $('.footable-paginated').trigger('footable_redraw');
                }
            });
        });

        $filterDailyButton.on('change', function (e) {
            dataPeriod = 'daily';

            bookingsChart.destroy();
            bookingsChart = Charter.line($bookingsChart, getLabels(bookings.daily, dataPeriod), [
                getCounts(bookings.daily),
            ]);
        });

        $filterMonthlyButton.on('change', function (e) {
            dataPeriod = 'monthly';

            bookingsChart.destroy();
            bookingsChart = Charter.line($bookingsChart, getLabels(bookings.monthly, dataPeriod), [
                getCounts(bookings.monthly),
            ]);
        });

        $backToChartViewLink.on('click', function (e) {
            $filterButtons.show();
        });
    }
})();



// WEBPACK FOOTER //
// ./resources/scripts/portal/pages/reports/bookings.js